import { GetFaviconUrl } from "common/Favicon";
import React from "react";

const TenantDomain = ({domain} : {domain: string}) => {
    return <div style={{display:"inline", padding: "5px 10px", background:"#D2E6FF", borderRadius:"20px"}}>
        <img alt={domain} src={GetFaviconUrl(domain)} style={{height:"22px", marginRight: "5px"}}/>{domain}
    </div>
}

export default TenantDomain;